import media from '@/styles/media';
import theme from '@/styles/theme';
import React, { useCallback } from 'react';
import styled from 'styled-components';

const Label = styled.label`
  padding: 10px 0 ;
`;

const Title = styled.div`
  color: ${theme.color.black};
  font-size: 13px;
  font-family: ${theme.fontFamily.regular};
  padding-bottom: 10px;

  ${media.md`
    font-size: 12px;
  `}
`;

export const InputElement = styled.input`
  max-width: 420px;
  width: 100%;
  height: 50px;
  padding: 0 13px;
  font-size: ${theme.fontSize.small};
  font-family: ${theme.fontFamily.regular};
  border-radius: 8px;
  background-color: ${theme.color.white};
  border: 2px solid #C3C9F8;
  box-shadow: 10px 10px 30px rgba(84, 100, 224, 0.1);

  ${media.lg`
    max-width: 100%;
  `}
  ${media.xs`
    font-size: 13px;
  `}
  &.reason {
    max-width: 450px;
    height: 54px;
    @media(max-width: 1320px){
      max-width: calc(100% + 30px);
      width: calc(100% + 30px);
    }
    ${media.xs`
      font-size: 13px;
    `}
  }

  &.mypage{
    @media(max-width: 1320px){
      max-width: 100%;
    }
  }
  :hover {
    border: 2px solid ${theme.color.inputHover};
  }

  :focus {
    outline: none;
    border: 2px solid ${theme.color.purple};
  }
  :disabled {
    color: ${theme.color.disabled};
    background-color: #F0F2FE;
  }

`;

const Error = styled.div`
  color: ${theme.color.red};
  text-align: right;
  padding-top: 5px;
  font-size: 13px;
  font-family: ${theme.fontFamily.medium};

  ${media.md`
    font-size: 12px;
  `}
`;

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  title?: string;
  errorText?: string;
  onPressEnter?: (value: string) => void;
}
export const InputText: React.FC<InputProps> = ({
  title,
  errorText,
  onPressEnter,
  ...restProps
}) => {
  const onPressKey = useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (restProps.onKeyPress) {
      restProps.onKeyPress(e);
    }
    if (e.key === 'Enter' && onPressEnter) {
      onPressEnter(e.currentTarget.value);
      e.preventDefault();
    }
  }, [onPressEnter, restProps]);

  return (
    <Label data-error={!!errorText}>
      {!!title && <Title>{title}</Title>}
      {!errorText ? (
        <InputElement {...restProps} onKeyPress={onPressKey} />
      ) : (
        // eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
        <InputElement {...restProps} onKeyPress={onPressKey} style={{ borderColor: '#DD3E3E' }} />
      )}
      {!!errorText && <Error>{errorText}</Error>}
    </Label>
  );
};
